// extracted by mini-css-extract-plugin
export default {"body":"src_body__+EVSi"};